(() => {
  const getProductInfo = (root) => root.closest('product-info');

  const clearMeasurementRecommendation = (root) => {
    const build = getProductInfo(root)?.querySelector('build-your-bandana[data-bandana-style]');
    if (!build) return;
    const input = build.querySelector('[data-neck-size]');
    const result = build.querySelector('[data-size-recommendation]');
    const error = build.querySelector('[data-neck-error]');
    if (input) {
      input.value = '';
      input.removeAttribute('aria-invalid');
    }
    if (result) {
      result.hidden = true;
      result.textContent = '';
    }
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    delete build.dataset.measurementInRange;
    delete build.dataset.measurementManualOverride;
  };

  const getSizeControl = (root, size) => {
    const productInfo = getProductInfo(root);
    const variantPicker = productInfo?.querySelector('variant-selects, variant-radios');
    if (!variantPicker) return null;

    const normalized = String(size || '').trim().toLowerCase();
    if (!normalized) return null;

    const sizeFieldset = Array.from(variantPicker.querySelectorAll('fieldset')).find((fieldset) =>
      String(fieldset.querySelector('legend')?.textContent || '').trim().toLowerCase().startsWith('size')
    );
    const radio = sizeFieldset && Array.from(sizeFieldset.querySelectorAll('input[type="radio"]')).find((item) =>
      String(item.value || '').trim().toLowerCase() === normalized
    );
    if (radio) return { type: 'input', element: radio };

    const select = Array.from(variantPicker.querySelectorAll('select')).find((item) => {
      const name = String(item.name || '').trim().toLowerCase();
      return name === 'options[size]' || name.includes('[size]');
    });
    const option = select && Array.from(select.options).find((item) =>
      String(item.value || '').trim().toLowerCase() === normalized
    );
    return option ? { type: 'select', element: select, value: option.value } : null;
  };

  const applySize = (root, size) => {
    const control = getSizeControl(root, size);
    const productInfo = getProductInfo(root);
    if (!control || !productInfo) return false;

    productInfo.dataset.hughiesApplyingSize = 'breed';
    if (control.type === 'input') {
      if (!control.element.checked) control.element.click();
    } else if (control.element.value !== control.value) {
      control.element.value = control.value;
      control.element.dispatchEvent(new Event('input', { bubbles: true }));
      control.element.dispatchEvent(new Event('change', { bubbles: true }));
    }
    window.setTimeout(() => delete productInfo.dataset.hughiesApplyingSize, 0);
    return control.type === 'input' ? control.element.checked : control.element.value === control.value;
  };

  const update = (root, select) => {
    const result = root.querySelector('[data-results]');
    const error = root.querySelector('[data-error]');
    const option = select.options[select.selectedIndex];
    const size = String(option?.dataset?.size || '').trim();
    const caption = String(option?.dataset?.caption || '').trim();

    if (!select.value) {
      if (result) {
        result.hidden = true;
        result.textContent = '';
      }
      if (error) error.hidden = true;
      return;
    }

    clearMeasurementRecommendation(root);
    if (!size) {
      if (result) {
        result.hidden = true;
        result.textContent = '';
      }
      if (error) error.hidden = false;
      return;
    }

    const selected = applySize(root, size);
    if (result) {
      result.textContent = selected
        ? `Recommended size: ${size} — automatically selected for you. For the best fit, check your dog's neck measurement.`
        : `Recommended starting size: ${size}. Please select ${size} above.${caption ? ` ${caption}` : ''}`;
      result.hidden = false;
    }
    if (error) error.hidden = true;
  };

  const isSizeControl = (target) => {
    if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return false;
    const fieldset = target.closest('fieldset');
    if (fieldset && String(fieldset.querySelector('legend')?.textContent || '').trim().toLowerCase().startsWith('size')) return true;
    return String(target.name || '').trim().toLowerCase().includes('[size]');
  };

  const initialise = (root) => {
    const select = root.querySelector('[data-breed-select]');
    if (!select || select.dataset.hughiesReady === 'true') return;
    select.dataset.hughiesReady = 'true';
    select.addEventListener('change', () => update(root, select));

    const productInfo = getProductInfo(root);
    if (productInfo && root.dataset.manualOverrideReady !== 'true') {
      root.dataset.manualOverrideReady = 'true';
      productInfo.addEventListener('change', (event) => {
        if (!isSizeControl(event.target) || productInfo.dataset.hughiesApplyingSize) return;
        const result = root.querySelector('[data-results]');
        const error = root.querySelector('[data-error]');
        select.value = '';
        if (result) {
          result.hidden = true;
          result.textContent = '';
        }
        if (error) error.hidden = true;
      });
    }

    if (select.value) update(root, select);
  };

  const initialiseAll = () => document.querySelectorAll('[data-hughies-breed-selector]').forEach(initialise);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }
  document.addEventListener('shopify:section:load', initialiseAll);
  document.addEventListener('product-info:loaded', initialiseAll);
})();
